export const distanceCharacteristic = ['Distance', 'DeployedLength', 'CompactedLength', 'Length', 'LengthA', 'LengthB', 'LengthC', 'Width', 'Diameter'];
